const key = 'referring_customer_id';

export const extractReferringCustomerId = (analytics: { [key: string]: string | undefined | null; qs: string }) => {
  if (localStorage.getItem(key)) {
    return { ...analytics, [key]: localStorage.getItem(key) as string };
  }

  if (analytics?.qs) {
    try {
      const urlParams = new URLSearchParams(analytics.qs);
      const referringCustomerId = urlParams.get(key);
      if (referringCustomerId) {
        localStorage.setItem(key, referringCustomerId);
        return { ...analytics, [key]: referringCustomerId };
      }
    } catch (e) {
      // No need to do anything if the qs is malformed or the referring_customer_id is not present
    }
  }

  return analytics;
};
